import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatTableTopX } from 'src/utils/table';

import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';

function DlpViolators(props: { data: any; day: string }) {
  const { t } = useTranslation();

  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.user'),
    t('dashboard.chart.column.occurrences'),
  ];

  const data = formatTableTopX(
    props.data?.data_protectionCounts?.[props.day]?.top_5_slf_violators,
    ['key', 'doc_count'],
    t
  );

  return (
    <DashboardCard title={t('dashboard.chart.title.dlpViolators')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(DlpViolators);
